const ITEMGROUPS = {
    WEAPON: {
        1: [
            'SWORD_001',
            'MACE_001',
            'DAGGER_001',
        ],
        2: [
            'SWORD_011',
            // 'BOW_001', // ToDo: implement 1hand, 2hand, dual wield logic first
        ],
        3: [],
    },
    ARMOR: {
        1: [
            'SHIELD_001',
            'TORSO_001',
            'TROUSERS_001',
            'BOOTS_001',
            'GLOVES_001',
        ],
        2: [
            'SHIELD_011',
        ],
        3: [],
    },
    SET: {
        FIRE: [
            'SWORD_011',
        ],
        EARTH: [
            'SHIELD_011',
        ],
    },
}

export default ITEMGROUPS
